// extracted by mini-css-extract-plugin
export default {"NoOptionsPlaceholder":"NoOptionPlaceholder_NoOptionsPlaceholder__Jk3-G","NoOptionsPlaceholderWithIcon":"NoOptionPlaceholder_NoOptionsPlaceholderWithIcon__zJMY2"};